module.exports = __webpack_public_path__ + "static/img/企业股权模块.568adb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/企业股权模块.png
// module id = s5aE
// module chunks = 1